
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const validateTransactionData = {
  validateCustomer: async (
    customerName: string, 
    selectedCustomer: any,
    setIsNewCustomerDialogOpen: (isOpen: boolean) => void
  ) => {
    if (!customerName.trim()) {
      toast.error("Cliente obrigatório para registrar uma entrada");
      return { success: false };
    }

    if (!selectedCustomer) {
      const { data: customers, error: customerError } = await supabase
        .from('customers')
        .select()
        .ilike('name', customerName.trim())
        .limit(1);

      if (customerError) {
        console.error("Erro ao verificar cliente:", customerError);
        throw customerError;
      }

      if (!customers?.length) {
        setIsNewCustomerDialogOpen(true);
        return { success: false, needsNewCustomer: true };
      }

      // This will be handled by the parent component
      return { success: false, newCustomer: customers[0] };
    }

    return { success: true };
  },

  validateAmount: (amount: string) => {
    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount) || numericAmount <= 0) {
      return { 
        success: false, 
        message: "O valor da transação deve ser maior que zero" 
      };
    }
    return { success: true };
  }
};
